(function () {
  'use strict';

  /* =========================================================
     Chart 1 — Coffee Nerdery Wheel (Sunburst / Hierarchy)
     ========================================================= */
  function flavourChart() {
    am5.ready(function () {
      var root = am5.Root.new('flavour-chart');
      root.setThemes([am5themes_Animated.new(root)]);

      var container = root.container.children.push(
        am5.ZoomableContainer.new(root, {
          width: am5.p100,
          height: am5.p100,
          layout: root.verticalLayout,
          wheelable: true,
          pinchZoom: true,
        })
      );

      container.children.push(am5.ZoomTools.new(root, { target: container }));

      container.contents.children.push(
        am5.Label.new(root, {
          text: 'Coffee\nNerdery[/]\nWheel[/]',
          textAlign: 'center',
          x: am5.p50,
          y: am5.p50,
          centerX: am5.p50,
          centerY: am5.p50,
          fontSize: 18,
          fontWeight: '500',
          fill: am5.color(0x131313),
        })
      );

      var credits = container.children.push(
        am5.Label.new(root, {
          text: "Inspired by\n[bold]The Coffee Taster's\nFlavor Wheel",
          x: am5.p100,
          y: 0,
          centerX: am5.p100,
          centerY: 0,
          fontSize: 15,
          fill: am5.color(0x385d63),
          cursorOverStyle: 'pointer',
          background: am5.Rectangle.new(root, { fill: am5.color(0x000000), fillOpacity: 0 }),
        })
      );
      credits.events.on('click', function () {
        window.open('https://sca.coffee/research/coffee-tasters-flavor-wheel');
      });

      var series = container.contents.children.push(
        am5hierarchy.Sunburst.new(root, {
          singleBranchOnly: true,
          downDepth: 2,
          initialDepth: 2,
          topDepth: 1,
          innerRadius: 50,
          valueField: 'value',
          categoryField: 'name',
          childDataField: 'children',
        })
      );

      series.nodes.template.setAll({ tooltipText: "{category}: {valuePercentTotal.formatNumber('0.00')}%" });
      series.slices.template.setAll({ templateField: 'nodeSettings', strokeWidth: 0.5 });
      series.labels.template.setAll({
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 2,
        paddingBottom: 2,
        baseRadius: am5.p100,
        centerX: am5.p100,
        textAlign: 'start',
      });

      var data = [
        {
          name: 'COFFEE Tasting Notes',
          children: [
            {
              name: 'Fruity',
              nodeSettings: { fill: am5.color(0xde553d) },
              children: [
                {
                  name: 'Berries',
                  nodeSettings: { fill: am5.color(0xff6347) },
                  children: [
                    { name: 'Strawberry', value: 32, nodeSettings: { fill: am5.color(0xc9356a) } },
                    { name: 'Blueberry', value: 25, nodeSettings: { fill: am5.color(0x2a5ebf) } },
                    { name: 'Raspberry', value: 23, nodeSettings: { fill: am5.color(0xb00033) } },
                    { name: 'Blackberry', value: 18, nodeSettings: { fill: am5.color(0x331f6a) } },
                    { name: 'Blackcurrant', value: 16, nodeSettings: { fill: am5.color(0x2a1f1f) } },
                    { name: 'Grape', value: 16, nodeSettings: { fill: am5.color(0x4c1785) } },
                    { name: 'Redcurrant', value: 7, nodeSettings: { fill: am5.color(0xb00033) } },
                    { name: 'Tomato', value: 3, nodeSettings: { fill: am5.color(0xcc3f1f) } },
                    { name: 'Gooseberry', value: 2, nodeSettings: { fill: am5.color(0x6f8c00) } },
                    { name: 'Goji Berries', value: 1, nodeSettings: { fill: am5.color(0xcc2800) } },
                    { name: 'Persimmon / Sharon fruit', value: 1, nodeSettings: { fill: am5.color(0xd14a1e) } },
                  ],
                },
                {
                  name: 'Stonefruits or\nDrupes',
                  nodeSettings: { fill: am5.color(0xff6347) },
                  children: [
                    { name: 'Cherry', value: 47, nodeSettings: { fill: am5.color(0x9b0017) } },
                    { name: 'Peach', value: 38, nodeSettings: { fill: am5.color(0xc9ad7f) } },
                    { name: 'Plum', value: 37, nodeSettings: { fill: am5.color(0x682d61) } },
                    { name: 'Apricot', value: 20, nodeSettings: { fill: am5.color(0xc78e69) } },
                    { name: 'Nectarine', value: 5, nodeSettings: { fill: am5.color(0xcc7d1b) } },
                  ],
                },
                {
                  name: 'Core or\nPommes',
                  nodeSettings: { fill: am5.color(0xff6347) },
                  children: [
                    { name: 'Apple', value: 51, nodeSettings: { fill: am5.color(0xcc0600) } },
                    { name: 'Pear', value: 17, nodeSettings: { fill: am5.color(0x919b00) } },
                    { name: 'Toffee Apple', value: 1, nodeSettings: { fill: am5.color(0x6f3003) } },
                  ],
                },
                {
                  name: 'Citrus',
                  nodeSettings: { fill: am5.color(0xff6347) },
                  children: [
                    { name: 'Orange', value: 64, nodeSettings: { fill: am5.color(0xcc7700) } },
                    { name: 'Lemon', value: 41, nodeSettings: { fill: am5.color(0xb3ae00) } },
                    { name: 'Lime', value: 13, nodeSettings: { fill: am5.color(0x1d8d0f) } },
                    { name: 'Grapefruit', value: 9, nodeSettings: { fill: am5.color(0xc93d34) } },
                    { name: 'Mandarin', value: 8, nodeSettings: { fill: am5.color(0xcc7700) } },
                    { name: 'Tangerine', value: 6, nodeSettings: { fill: am5.color(0xbf5c00) } },
                    { name: 'Clementine', value: 2, nodeSettings: { fill: am5.color(0xcc7700) } },
                    { name: 'Kumquat', value: 2, nodeSettings: { fill: am5.color(0xcc7700) } },
                    { name: 'Pomelo', value: 1, nodeSettings: { fill: am5.color(0xb3ae00) } },
                  ],
                },
                {
                  name: 'Melons',
                  nodeSettings: { fill: am5.color(0xff6347) },
                  children: [
                    { name: 'Watermelon', value: 3, nodeSettings: { fill: am5.color(0xc5405e) } },
                    { name: 'Cantaloupe', value: 1, nodeSettings: { fill: am5.color(0xc7914a) } },
                  ],
                },
                {
                  name: 'Tropical/\nExotic',
                  nodeSettings: { fill: am5.color(0xff6347) },
                  children: [
                    { name: 'Mango', value: 22, nodeSettings: { fill: am5.color(0xb3ae00) } },
                    { name: 'Pineapple', value: 19, nodeSettings: { fill: am5.color(0xb3ae00) } },
                    { name: 'Passion fruit', value: 12, nodeSettings: { fill: am5.color(0xb343cc) } },
                    { name: 'Guava', value: 9, nodeSettings: { fill: am5.color(0xcc8e9a) } },
                    { name: 'Lychee', value: 6, nodeSettings: { fill: am5.color(0xa60017) } },
                    { name: 'Papaya', value: 6, nodeSettings: { fill: am5.color(0xcc7700) } },
                    { name: 'Banana', value: 5, nodeSettings: { fill: am5.color(0xb3ae00) } },
                    { name: 'Coconut', value: 3, nodeSettings: { fill: am5.color(0x6f3a1f) } },
                    { name: 'Pomegranate', value: 3, nodeSettings: { fill: am5.color(0x9b0017) } },
                    { name: 'Kiwi', value: 2, nodeSettings: { fill: am5.color(0x4d7a28) } },
                    { name: 'Dragon Fruit / Pitaya', value: 1, nodeSettings: { fill: am5.color(0xcc0066) } },
                    { name: 'Carambola / Star Fruit', value: 1, nodeSettings: { fill: am5.color(0xc0a400) } },
                  ],
                },
                {
                  name: 'Dried fruits',
                  nodeSettings: { fill: am5.color(0xff6347) },
                  children: [
                    { name: 'Raisin', value: 27, nodeSettings: { fill: am5.color(0x6f3003) } },
                    { name: 'Dates', value: 13, nodeSettings: { fill: am5.color(0x6f3003) } },
                    { name: 'Cranberry', value: 11, nodeSettings: { fill: am5.color(0x780014) } },
                    { name: 'Sultana', value: 5, nodeSettings: { fill: am5.color(0xa04f0f) } },
                    { name: 'Prune', value: 3, nodeSettings: { fill: am5.color(0x1f0a22) } },
                  ],
                },
              ],
            },
            {
              name: 'Floral',
              nodeSettings: { fill: am5.color(0xde9ea7) },
              children: [
                {
                  name: 'Flowery',
                  nodeSettings: { fill: am5.color(0xffb6c1) },
                  children: [
                    { name: 'Jasmine', value: 4, nodeSettings: { fill: am5.color(0xadacaf) } },
                    { name: 'Hibiscus', value: 2, nodeSettings: { fill: am5.color(0xcc3f8e) } },
                    { name: 'Heuchera / Cherry Cola', value: 1, nodeSettings: { fill: am5.color(0x660000) } },
                    { name: 'Coffee blossom', value: 1, nodeSettings: { fill: am5.color(0xb3afa8) } },
                    { name: 'Elderflower', value: 1, nodeSettings: { fill: am5.color(0xadacaf) } },
                  ],
                },
                {
                  name: 'Tea like',
                  nodeSettings: { fill: am5.color(0xffb6c1) },
                  children: [
                    { name: 'Black tea', value: 4, nodeSettings: { fill: am5.color(0x36211e) } },
                    { name: 'Green tea', value: 1, nodeSettings: { fill: am5.color(0x5e9e5e) } },
                    { name: 'Rooibos tea', value: 1, nodeSettings: { fill: am5.color(0x8c2800) } },
                    { name: 'Earl Grey tea', value: 1, nodeSettings: { fill: am5.color(0x36211e) } },
                  ],
                },
              ],
            },
            {
              name: 'Vegetative',
              nodeSettings: { fill: am5.color(0x1c781c) },
              children: [
                {
                  name: 'Hay-like and\nHerb-like',
                  nodeSettings: { fill: am5.color(0x228b22) },
                  children: [
                    { name: 'Lemongrass', value: 3, nodeSettings: { fill: am5.color(0x569e00) } },
                    { name: 'Herb-like', value: 2, nodeSettings: { fill: am5.color(0x4d6f40) } },
                    { name: 'Marjoram', value: 1, nodeSettings: { fill: am5.color(0x4d6f40) } },
                  ],
                },
                {
                  name: 'Fresh and\nDark Green',
                  nodeSettings: { fill: am5.color(0x228b22) },
                  children: [{ name: 'Rhubarb', value: 2, nodeSettings: { fill: am5.color(0x78292b) } }],
                },
                {
                  name: 'Cereal',
                  nodeSettings: { fill: am5.color(0x228b22) },
                  children: [{ name: 'Malt', value: 17, nodeSettings: { fill: am5.color(0x8b764a) } }],
                },
              ],
            },
            {
              name: 'Basic\nTastes',
              nodeSettings: { fill: am5.color(0xbd8f1a) },
              children: [
                {
                  name: 'Sweet',
                  nodeSettings: { fill: am5.color(0xdaa520) },
                  children: [
                    { name: 'Caramel', value: 63, nodeSettings: { fill: am5.color(0x7f5228) } },
                    { name: 'Toffee', value: 18, nodeSettings: { fill: am5.color(0xa04f0f) } },
                    { name: 'Honey', value: 16, nodeSettings: { fill: am5.color(0x917a34) } },
                    { name: 'Vanilla', value: 14, nodeSettings: { fill: am5.color(0xbaa96f) } },
                    { name: 'Sweet Aromatics', value: 13, nodeSettings: { fill: am5.color(0xb3ae00) } },
                    { name: 'Praline', value: 11, nodeSettings: { fill: am5.color(0xa04f0f) } },
                    { name: 'Brown sugar', value: 8, nodeSettings: { fill: am5.color(0x917a34) } },
                    { name: 'Molasses', value: 8, nodeSettings: { fill: am5.color(0x1f0a22) } },
                    { name: 'Sugarcane', value: 7, nodeSettings: { fill: am5.color(0xb5a84c) } },
                    { name: 'Maple Syrup', value: 5, nodeSettings: { fill: am5.color(0x917a34) } },
                    { name: 'Marzipan', value: 4, nodeSettings: { fill: am5.color(0xbfa892) } },
                    { name: 'Golden syrup', value: 4, nodeSettings: { fill: am5.color(0xb3ae00) } },
                    { name: 'Butterscotch', value: 4, nodeSettings: { fill: am5.color(0xa04f0f) } },
                    { name: 'Banoffee', value: 3, nodeSettings: { fill: am5.color(0x7f5228) } },
                    { name: 'Muscovado sugar', value: 3, nodeSettings: { fill: am5.color(0x6f3003) } },
                    { name: 'Overall sweet', value: 2, nodeSettings: { fill: am5.color(0xb3ae00) } },
                    { name: 'Fudge', value: 2, nodeSettings: { fill: am5.color(0x321b11) } },
                    { name: 'Marmalade toast', value: 2, nodeSettings: { fill: am5.color(0xcc7700) } },
                    { name: 'Honeycomb', value: 2, nodeSettings: { fill: am5.color(0xb5a84c) } },
                    { name: 'Orange marmalade', value: 1, nodeSettings: { fill: am5.color(0xcc7700) } },
                    { name: 'Wine gum', value: 1, nodeSettings: { fill: am5.color(0x682d61) } },
                    { name: 'Tart /Cheesecake', value: 1, nodeSettings: { fill: am5.color(0xc5a8a6) } },
                    { name: 'Chocolate brownie', value: 1, nodeSettings: { fill: am5.color(0x321b11) } },
                    { name: 'Peanut butter', value: 1, nodeSettings: { fill: am5.color(0xa04f0f) } },
                    { name: 'Strawberry jam', value: 1, nodeSettings: { fill: am5.color(0xc9356a) } },
                    { name: 'Panela sweetness / Rapadura', value: 1, nodeSettings: { fill: am5.color(0x917a34) } },
                  ],
                },
                {
                  name: 'Bitter and\nButtery',
                  nodeSettings: { fill: am5.color(0xdaa520) },
                  children: [
                    { name: 'Milk Chocolate', value: 125, nodeSettings: { fill: am5.color(0x432416) } },
                    { name: 'Dark Chocolate', value: 86, nodeSettings: { fill: am5.color(0x3b2f2f) } },
                    { name: 'Cocoa', value: 41, nodeSettings: { fill: am5.color(0x2a1509) } },
                    { name: 'Cacao', value: 7, nodeSettings: { fill: am5.color(0x4b3832) } },
                    { name: 'Butter', value: 6, nodeSettings: { fill: am5.color(0xad9c71) } },
                    { name: 'White Chocolate', value: 3, nodeSettings: { fill: am5.color(0xb3afa8) } },
                  ],
                },
                {
                  name: 'Spicy',
                  nodeSettings: { fill: am5.color(0xdaa520) },
                  children: [
                    { name: 'Nutmeg', value: 4, nodeSettings: { fill: am5.color(0x4c3821) } },
                    { name: 'Cinnamon', value: 3, nodeSettings: { fill: am5.color(0x6f512d) } },
                    { name: 'Clove', value: 3, nodeSettings: { fill: am5.color(0x2f281e) } },
                    { name: 'Tamarind', value: 2, nodeSettings: { fill: am5.color(0x6f3003) } },
                    { name: 'Pepper', value: 2, nodeSettings: { fill: am5.color(0x2f271c) } },
                    { name: 'Pungent', value: 1, nodeSettings: { fill: am5.color(0xcc2800) } },
                    { name: 'Ginger', value: 1, nodeSettings: { fill: am5.color(0x864940) } },
                  ],
                },
                {
                  name: 'Nutty',
                  nodeSettings: { fill: am5.color(0xdaa520) },
                  children: [
                    { name: 'Hazelnut', value: 38, nodeSettings: { fill: am5.color(0x432d19) } },
                    { name: 'Almond', value: 22, nodeSettings: { fill: am5.color(0x544938) } },
                    { name: 'Walnut', value: 9, nodeSettings: { fill: am5.color(0x694f34) } },
                    { name: 'Pecans', value: 6, nodeSettings: { fill: am5.color(0x694f34) } },
                    { name: 'Cashew', value: 4, nodeSettings: { fill: am5.color(0xad987f) } },
                    { name: 'Peanuts', value: 4, nodeSettings: { fill: am5.color(0xa5906d) } },
                    { name: 'Pistachio', value: 2, nodeSettings: { fill: am5.color(0x6c8748) } },
                    { name: 'Macadamia', value: 2, nodeSettings: { fill: am5.color(0xbfa892) } },
                    { name: 'Chestnut', value: 1, nodeSettings: { fill: am5.color(0x6a2e21) } },
                    { name: 'Pine nut', value: 1, nodeSettings: { fill: am5.color(0xa04f0f) } },
                  ],
                },
                {
                  name: 'Sour',
                  nodeSettings: { fill: am5.color(0xdaa520) },
                  children: [
                    { name: 'Citric acid', value: 2, nodeSettings: { fill: am5.color(0xb3ae00) } },
                    { name: 'Malic acid', value: 2, nodeSettings: { fill: am5.color(0x1d8d0f) } },
                  ],
                },
                {
                  name: 'Biscuity',
                  nodeSettings: { fill: am5.color(0xdaa520) },
                  children: [
                    { name: 'Biscuit', value: 15, nodeSettings: { fill: am5.color(0xbc7940) } },
                    { name: 'Shortbread', value: 12, nodeSettings: { fill: am5.color(0xbc7940) } },
                    { name: 'Biscoff', value: 2, nodeSettings: { fill: am5.color(0xa04f0f) } },
                    { name: 'Speculoos', value: 1, nodeSettings: { fill: am5.color(0xa04f0f) } },
                    { name: 'Gingerbread', value: 1, nodeSettings: { fill: am5.color(0xa04f0f) } },
                  ],
                },
              ],
            },
            {
              name: 'Unusual\nTastes',
              nodeSettings: { fill: am5.color(0x6e006e) },
              children: [
                {
                  name: 'Alcohol/\nFermented',
                  nodeSettings: { fill: am5.color(0x800080) },
                  children: [
                    { name: 'Winey', value: 1, nodeSettings: { fill: am5.color(0x510011) } },
                    { name: 'Bourbon', value: 1, nodeSettings: { fill: am5.color(0x9b5b1b) } },
                    { name: 'Whiskey', value: 1, nodeSettings: { fill: am5.color(0xa07a1b) } },
                  ],
                },
                {
                  name: 'Roasted/\nBurnt',
                  nodeSettings: { fill: am5.color(0x800080) },
                  children: [
                    { name: 'Smoky', value: 5, nodeSettings: { fill: am5.color(0x6d6d66) } },
                    { name: 'Roasted', value: 2, nodeSettings: { fill: am5.color(0x6f5c45) } },
                    { name: 'Liquorice', value: 1, nodeSettings: { fill: am5.color(0x0f0c0a) } },
                    { name: 'Tobacco', value: 1, nodeSettings: { fill: am5.color(0x544938) } },
                  ],
                },
                {
                  name: 'Chemical',
                  nodeSettings: { fill: am5.color(0x800080) },
                  children: [
                    { name: 'Bitter (Caffeine solution)', value: 2, nodeSettings: { fill: am5.color(0x2f271c) } },
                  ],
                },
                {
                  name: 'Industrial/\nPapery/\nMusty',
                  nodeSettings: { fill: am5.color(0x800080) },
                  children: [
                    { name: 'Woody', value: 3, nodeSettings: { fill: am5.color(0x724f36) } },
                    { name: 'Musty/earthy', value: 2, nodeSettings: { fill: am5.color(0x434033) } },
                  ],
                },
                {
                  name: 'Mouthfeeld',
                  nodeSettings: { fill: am5.color(0x800080) },
                  children: [{ name: 'Leather', value: 1, nodeSettings: { fill: am5.color(0x4d3829) } }],
                },
              ],
            },
          ],
        },
      ];

      series.data.setAll(data);
      series.set('selectedDataItem', series.dataItems[0]);
      series.appear(1000, 100);
    });
  }

  /* =========================================================
     Chart 2 — Countries of Origin (Map + Bubble)
     ========================================================= */
  function countryOfOriginChart() {
    am5.ready(function () {
      var data = [
        { id: 'CO', name: 'Colombia', value: 25.9 },
        { id: 'BR', name: 'Brazil', value: 18.7 },
        { id: 'ET', name: 'Ethiopia', value: 10.2 },
        { id: 'GT', name: 'Guatemala', value: 5 },
        { id: 'PE', name: 'Peru', value: 4.8 },
        { id: 'UG', name: 'Uganda', value: 4.1 },
        { id: 'KE', name: 'Kenya', value: 4 },
        { id: 'MX', name: 'Mexico', value: 3.6 },
        { id: 'RW', name: 'Rwanda', value: 3.4 },
        { id: 'HN', name: 'Honduras', value: 3.2 },
        { id: 'CR', name: 'Costa Rica', value: 3.2 },
        { id: 'SV', name: 'El Salvador', value: 2.2 },
        { id: 'ID', name: 'Indonesia', value: 2.1 },
        { id: 'NI', name: 'Nicaragua', value: 2 },
        { id: 'IN', name: 'India', value: 1.9 },
        { id: 'PG', name: 'Papua New Guinea', value: 1.7 },
        { id: 'BI', name: 'Burundi', value: 1.1 },
        { id: 'TZ', name: 'Tanzania', value: 0.8 },
        { id: 'CN', name: 'China', value: 0.5 },
        { id: 'VN', name: 'Vietnam', value: 0.4 },
        { id: 'BO', name: 'Bolivia', value: 0.4 },
        { id: 'ZM', name: 'Zambia', value: 0.3 },
        { id: 'EC', name: 'Ecuador', value: 0.3 },
        { id: 'JM', name: 'Jamaica', value: 0.1 },
        { id: 'PA', name: 'Panama', value: 0.1 },
        { id: 'AU', name: 'Australia', value: 0.1 },
      ];

      var root = am5.Root.new('chart-countryOrigin');
      root.setThemes([am5themes_Animated.new(root)]);

      var chart = root.container.children.push(
        am5map.MapChart.new(root, {
          homeZoomLevel: 1.3,
          homeGeoPoint: { longitude: 40.489673, latitude: 9.145 },
        })
      );

      var polygonSeries = chart.series.push(
        am5map.MapPolygonSeries.new(root, {
          geoJSON: am5geodata_worldLow,
          exclude: ['AQ'],
          fill: am5.color(0x01aa7a),
        })
      );

      polygonSeries.events.on('datavalidated', function () {
        chart.goHome();
      });

      var bubbleSeries = chart.series.push(
        am5map.MapPointSeries.new(root, {
          valueField: 'value',
          calculateAggregates: true,
          polygonIdField: 'id',
        })
      );

      var circleTemplate = am5.Template.new({});

      bubbleSeries.bullets.push(function (root, series, dataItem) {
        var container = am5.Container.new(root, {});

        var circle = container.children.push(
          am5.Circle.new(root, {
            radius: 20,
            fillOpacity: 0.9,
            fill: am5.color(0x131313),
            cursorOverStyle: 'pointer',
            tooltipText: '{name}: [bold]{value}%[/]',
          }, circleTemplate)
        );

        var countryLabel = container.children.push(
          am5.Label.new(root, {
            text: '{name}',
            paddingLeft: 5,
            populateText: true,
            fill: am5.color(0x131313),
            fontWeight: 'bold',
            fontSize: 12,
            centerY: am5.p50,
          })
        );

        circle.on('radius', function (radius) {
          countryLabel.set('x', radius);
        });

        return am5.Bullet.new(root, { sprite: container, dynamic: true });
      });

      bubbleSeries.bullets.push(function (root, series, dataItem) {
        return am5.Bullet.new(root, {
          sprite: am5.Label.new(root, {
            text: "{value.formatNumber('#')}%",
            fill: am5.color(0xffffff),
            populateText: true,
            centerX: am5.p50,
            centerY: am5.p50,
            textAlign: 'center',
            fontSize: 11,
          }),
          dynamic: true,
        });
      });

      bubbleSeries.set('heatRules', [
        {
          target: circleTemplate,
          dataField: 'value',
          min: 15,
          max: 50,
          minValue: 0,
          maxValue: 100,
          key: 'radius',
        },
      ]);

      bubbleSeries.data.setAll(data);
    });
  }

  /* =========================================================
     Chart 3 — Processing Methods (Pack / Hierarchy)
     ========================================================= */
  function processingMethodChart() {
    am5.ready(function () {
      var root = am5.Root.new('chart-ProcessingMethod');
      root.setThemes([am5themes_Animated.new(root)]);

      var zoomableContainer = root.container.children.push(
        am5.ZoomableContainer.new(root, {
          width: am5.p100,
          height: am5.p100,
          wheelable: true,
          pinchZoom: true,
        })
      );

      zoomableContainer.children.push(am5.ZoomTools.new(root, { target: zoomableContainer }));

      var series = zoomableContainer.contents.children.push(
        am5hierarchy.Pack.new(root, {
          maskContent: false,
          topDepth: 1,
          valueField: 'value',
          categoryField: 'name',
          childDataField: 'children',
        })
      );

      series.labels.template.setAll({
        textAlign: 'center',
        fontSize: 15,
        oversizedBehavior: 'truncate',
        ellipsis: '...',
        minScale: 0,
      });

      series.get('colors').set('colors', [
        am5.color(0x007751),
        am5.color(0xc9300d),
        am5.color(0xd8c066),
        am5.color(0x01aa7a),
        am5.color(0x5e291e),
        am5.color(0x00593d),
        am5.color(0x009688),
        am5.color(0xe73413),
        am5.color(0x7d4532),
        am5.color(0x006064),
        am5.color(0xffd101),
        am5.color(0x00838f),
        am5.color(0x4a148c),
        am5.color(0x3e2723),
        am5.color(0xffa000),
        am5.color(0xd84315),
        am5.color(0xb71c1c),
        am5.color(0x6d4c41),
        am5.color(0x33691e),
        am5.color(0x2e7d32),
      ]);

      series.nodes.template.setAll({ tooltipText: "{category}: {valuePercentTotal.formatNumber('0.00')}%" });

      var data = {
        name: 'Root',
        children: [
          { name: 'Washed / Wet', value: 387 },
          { name: 'Natural / Dry', value: 198 },
          { name: 'Sugar Cane Decaffeination', value: 50 },
          { name: 'Honey / Pulped natural', value: 45 },
          { name: 'Swiss Water Decaf', value: 33 },
          { name: 'Anaerobic', value: 28 },
          { name: 'Wet Hulled (Semi - Washed/Giling Basah)', value: 13 },
          { name: 'Mountain Water Process', value: 7 },
          { name: 'Monsoon Malabar', value: 6 },
          { name: 'Carbonic Maceration (CO2)', value: 5 },
          { name: 'Yeast Fermentation', value: 3 },
          { name: 'Anoxic', value: 1 },
          { name: 'MC Decaf (Methylene Chloride)', value: 1 },
          { name: 'Sparkling Water Decaf', value: 1 },
          { name: 'White Wine Extended Fermentation (WWEF)', value: 1 },
          { name: 'Lactic process', value: 0 },
          { name: 'Dry Fermented', value: 0 },
          { name: 'Natural / Extended Fermentation', value: 0 },
          { name: 'Rum infused', value: 0 },
          { name: 'Unripe Cherries (Maceration tanks)', value: 0 },
        ],
      };

      series.data.setAll([data]);
      series.appear(1000, 100);
    });
  }

  /* =========================================================
     Chart 4 — Processing Method by Country (ForceDirected)
     ========================================================= */
  function processingByCountryChart() {
    am5.ready(function () {
      var root = am5.Root.new('chart-ProcessByCountry2');
      root.setThemes([am5themes_Animated.new(root)]);

      var container = root.container.children.push(
        am5.ZoomableContainer.new(root, {
          width: am5.percent(100),
          height: am5.percent(100),
          wheelable: true,
          pinchZoom: true,
          layout: root.verticalLayout,
        })
      );

      container.children.push(am5.ZoomTools.new(root, { target: container }));

      var series = container.contents.children.push(
        am5hierarchy.ForceDirected.new(root, {
          downDepth: 1,
          initialDepth: 1,
          singleBranchOnly: true,
          valueField: 'value',
          categoryField: 'name',
          childDataField: 'children',
        })
      );

      series.labels.template.setAll({ textAlign: 'center', fontSize: 10, ellipsis: '...', minScale: 0 });
      series.nodes.template.setAll({ tooltipText: "{category}: {valuePercentTotal.formatNumber('0.00')}%" });
      series.circles.template.setAll({ templateField: 'nodeSettings' });
      series.outerCircles.template.setAll({ templateField: 'nodeSettings' });
      series.links.template.adapters.add('stroke', function () {
        return am5.color(0x01aa7a);
      });

      series.data.setAll([
        {
          name: 'All coffees',
          value: 779,
          nodeSettings: { fill: am5.color(0x01aa7a), stroke: am5.color(0x01aa7a) },
          children: [
            {
              name: 'Colombia', value: 147,
              nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) },
              children: [
                { name: 'Natural / Dry', value: 14, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
                { name: 'Washed / Wet', value: 91, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
                { name: 'Honey / Pulped natural', value: 6, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
                { name: 'Anaerobic', value: 3, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
                { name: 'Carbonic Maceration (CO2)', value: 1, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
                { name: 'Swiss Water Decaf', value: 4, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
                { name: 'Wet Hulled (Semi - Washed/Giling Basah)', value: 2, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
                { name: 'Natural / Extended Fermentation', value: 4, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
                { name: 'Sugar Cane Decaffeination', value: 22, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
                { name: 'Other', value: 5, nodeSettings: { fill: am5.color(0xd35400), stroke: am5.color(0xd35400) } },
              ],
            },
            {
              name: 'Brazil', value: 125,
              nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) },
              children: [
                { name: 'Natural / Dry', value: 78, nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) } },
                { name: 'Washed / Wet', value: 17, nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) } },
                { name: 'Honey / Pulped natural', value: 13, nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) } },
                { name: 'Carbonic Maceration (CO2)', value: 1, nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) } },
                { name: 'Swiss Water Decaf', value: 11, nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) } },
                { name: 'Natural / Extended Fermentation', value: 3, nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) } },
                { name: 'Sugar Cane Decaffeination', value: 1, nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) } },
                { name: 'MC Decaf (Methylene Chloride)', value: 1, nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) } },
                { name: 'Other', value: 2, nodeSettings: { fill: am5.color(0x196f3d), stroke: am5.color(0x196f3d) } },
              ],
            },
            {
              name: 'Ethiopia', value: 64,
              nodeSettings: { fill: am5.color(0x6e2c00), stroke: am5.color(0x6e2c00) },
              children: [
                { name: 'Natural / Dry', value: 29, nodeSettings: { fill: am5.color(0x6e2c00), stroke: am5.color(0x6e2c00) } },
                { name: 'Washed / Wet', value: 30, nodeSettings: { fill: am5.color(0x6e2c00), stroke: am5.color(0x6e2c00) } },
                { name: 'Anaerobic', value: 2, nodeSettings: { fill: am5.color(0x6e2c00), stroke: am5.color(0x6e2c00) } },
                { name: 'Swiss Water Decaf', value: 2, nodeSettings: { fill: am5.color(0x6e2c00), stroke: am5.color(0x6e2c00) } },
                { name: 'White Wine Extended Fermentation (WWEF)', value: 1, nodeSettings: { fill: am5.color(0x6e2c00), stroke: am5.color(0x6e2c00) } },
              ],
            },
            {
              name: 'Guatemala', value: 33,
              nodeSettings: { fill: am5.color(0x1f618d), stroke: am5.color(0x1f618d) },
              children: [
                { name: 'Natural / Dry', value: 4, nodeSettings: { fill: am5.color(0x1f618d), stroke: am5.color(0x1f618d) } },
                { name: 'Washed / Wet', value: 24, nodeSettings: { fill: am5.color(0x1f618d), stroke: am5.color(0x1f618d) } },
                { name: 'Honey / Pulped natural', value: 1, nodeSettings: { fill: am5.color(0x1f618d), stroke: am5.color(0x1f618d) } },
                { name: 'Anaerobic', value: 1, nodeSettings: { fill: am5.color(0x1f618d), stroke: am5.color(0x1f618d) } },
                { name: 'Carbonic Maceration (CO2)', value: 1, nodeSettings: { fill: am5.color(0x1f618d), stroke: am5.color(0x1f618d) } },
                { name: 'Swiss Water Decaf', value: 1, nodeSettings: { fill: am5.color(0x1f618d), stroke: am5.color(0x1f618d) } },
                { name: 'Sugar Cane Decaffeination', value: 1, nodeSettings: { fill: am5.color(0x1f618d), stroke: am5.color(0x1f618d) } },
                { name: 'Other', value: 1, nodeSettings: { fill: am5.color(0x1f618d), stroke: am5.color(0x1f618d) } },
              ],
            },
            {
              name: 'Peru', value: 30,
              nodeSettings: { fill: am5.color(0xa04000), stroke: am5.color(0xa04000) },
              children: [
                { name: 'Natural / Dry', value: 4, nodeSettings: { fill: am5.color(0xa04000), stroke: am5.color(0xa04000) } },
                { name: 'Washed / Wet', value: 22, nodeSettings: { fill: am5.color(0xa04000), stroke: am5.color(0xa04000) } },
                { name: 'Swiss Water Decaf', value: 4, nodeSettings: { fill: am5.color(0xa04000), stroke: am5.color(0xa04000) } },
              ],
            },
            {
              name: 'Uganda', value: 27,
              nodeSettings: { fill: am5.color(0x7b241c), stroke: am5.color(0x7b241c) },
              children: [
                { name: 'Natural / Dry', value: 16, nodeSettings: { fill: am5.color(0x7b241c), stroke: am5.color(0x7b241c) } },
                { name: 'Washed / Wet', value: 11, nodeSettings: { fill: am5.color(0x7b241c), stroke: am5.color(0x7b241c) } },
              ],
            },
            {
              name: 'Kenya', value: 26,
              nodeSettings: { fill: am5.color(0x922b21), stroke: am5.color(0x922b21) },
              children: [
                { name: 'Natural / Dry', value: 1, nodeSettings: { fill: am5.color(0x922b21), stroke: am5.color(0x922b21) } },
                { name: 'Washed / Wet', value: 23, nodeSettings: { fill: am5.color(0x922b21), stroke: am5.color(0x922b21) } },
                { name: 'Natural / Extended Fermentation', value: 1, nodeSettings: { fill: am5.color(0x922b21), stroke: am5.color(0x922b21) } },
                { name: 'Sugar Cane Decaffeination', value: 1, nodeSettings: { fill: am5.color(0x922b21), stroke: am5.color(0x922b21) } },
                { name: 'Other', value: 2, nodeSettings: { fill: am5.color(0x922b21), stroke: am5.color(0x922b21) } },
              ],
            },
            {
              name: 'Rwanda', value: 24,
              nodeSettings: { fill: am5.color(0xb7950b), stroke: am5.color(0xb7950b) },
              children: [
                { name: 'Natural / Dry', value: 5, nodeSettings: { fill: am5.color(0xb7950b), stroke: am5.color(0xb7950b) } },
                { name: 'Washed / Wet', value: 16, nodeSettings: { fill: am5.color(0xb7950b), stroke: am5.color(0xb7950b) } },
                { name: 'Honey / Pulped natural', value: 1, nodeSettings: { fill: am5.color(0xb7950b), stroke: am5.color(0xb7950b) } },
                { name: 'Anaerobic', value: 1, nodeSettings: { fill: am5.color(0xb7950b), stroke: am5.color(0xb7950b) } },
                { name: 'Swiss Water Decaf', value: 1, nodeSettings: { fill: am5.color(0xb7950b), stroke: am5.color(0xb7950b) } },
              ],
            },
            {
              name: 'Mexico', value: 23,
              nodeSettings: { fill: am5.color(0x145a32), stroke: am5.color(0x145a32) },
              children: [
                { name: 'Natural / Dry', value: 2, nodeSettings: { fill: am5.color(0x145a32), stroke: am5.color(0x145a32) } },
                { name: 'Washed / Wet', value: 14, nodeSettings: { fill: am5.color(0x145a32), stroke: am5.color(0x145a32) } },
                { name: 'Anaerobic', value: 1, nodeSettings: { fill: am5.color(0x145a32), stroke: am5.color(0x145a32) } },
                { name: 'Swiss Water Decaf', value: 2, nodeSettings: { fill: am5.color(0x145a32), stroke: am5.color(0x145a32) } },
                { name: 'Mountain Water Process', value: 4, nodeSettings: { fill: am5.color(0x145a32), stroke: am5.color(0x145a32) } },
              ],
            },
            {
              name: 'Honduras', value: 22,
              nodeSettings: { fill: am5.color(0x117a65), stroke: am5.color(0x117a65) },
              children: [
                { name: 'Natural / Dry', value: 2, nodeSettings: { fill: am5.color(0x117a65), stroke: am5.color(0x117a65) } },
                { name: 'Washed / Wet', value: 16, nodeSettings: { fill: am5.color(0x117a65), stroke: am5.color(0x117a65) } },
                { name: 'Honey / Pulped natural', value: 1, nodeSettings: { fill: am5.color(0x117a65), stroke: am5.color(0x117a65) } },
                { name: 'Swiss Water Decaf', value: 3, nodeSettings: { fill: am5.color(0x117a65), stroke: am5.color(0x117a65) } },
              ],
            },
            {
              name: 'Costa Rica', value: 20,
              nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) },
              children: [
                { name: 'Natural / Dry', value: 3, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } },
                { name: 'Washed / Wet', value: 9, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } },
                { name: 'Honey / Pulped natural', value: 6, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } },
                { name: 'Anaerobic', value: 1, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } },
                { name: 'Swiss Water Decaf', value: 1, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } },
                { name: 'Other', value: 1, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } },
              ],
            },
            {
              name: 'Nicaragua', value: 15,
              nodeSettings: { fill: am5.color(0x1b4f72), stroke: am5.color(0x1b4f72) },
              children: [
                { name: 'Washed / Wet', value: 12, nodeSettings: { fill: am5.color(0x1b4f72), stroke: am5.color(0x1b4f72) } },
                { name: 'Honey / Pulped natural', value: 1, nodeSettings: { fill: am5.color(0x1b4f72), stroke: am5.color(0x1b4f72) } },
                { name: 'Swiss Water Decaf', value: 1, nodeSettings: { fill: am5.color(0x1b4f72), stroke: am5.color(0x1b4f72) } },
                { name: 'Yeast Fermentation', value: 1, nodeSettings: { fill: am5.color(0x1b4f72), stroke: am5.color(0x1b4f72) } },
              ],
            },
            {
              name: 'El Salvador', value: 13,
              nodeSettings: { fill: am5.color(0x2e86c1), stroke: am5.color(0x2e86c1) },
              children: [
                { name: 'Natural / Dry', value: 2, nodeSettings: { fill: am5.color(0x2e86c1), stroke: am5.color(0x2e86c1) } },
                { name: 'Washed / Wet', value: 8, nodeSettings: { fill: am5.color(0x2e86c1), stroke: am5.color(0x2e86c1) } },
                { name: 'Honey / Pulped natural', value: 2, nodeSettings: { fill: am5.color(0x2e86c1), stroke: am5.color(0x2e86c1) } },
                { name: 'Anaerobic', value: 1, nodeSettings: { fill: am5.color(0x2e86c1), stroke: am5.color(0x2e86c1) } },
              ],
            },
            {
              name: 'Indonesia', value: 13,
              nodeSettings: { fill: am5.color(0x4d5656), stroke: am5.color(0x4d5656) },
              children: [
                { name: 'Natural / Dry', value: 1, nodeSettings: { fill: am5.color(0x4d5656), stroke: am5.color(0x4d5656) } },
                { name: 'Washed / Wet', value: 3, nodeSettings: { fill: am5.color(0x4d5656), stroke: am5.color(0x4d5656) } },
                { name: 'Swiss Water Decaf', value: 1, nodeSettings: { fill: am5.color(0x4d5656), stroke: am5.color(0x4d5656) } },
                { name: 'Wet Hulled (Semi - Washed/Giling Basah)', value: 8, nodeSettings: { fill: am5.color(0x4d5656), stroke: am5.color(0x4d5656) } },
              ],
            },
            {
              name: 'India', value: 10,
              nodeSettings: { fill: am5.color(0xba4a00), stroke: am5.color(0xba4a00) },
              children: [
                { name: 'Natural / Dry', value: 2, nodeSettings: { fill: am5.color(0xba4a00), stroke: am5.color(0xba4a00) } },
                { name: 'Washed / Wet', value: 3, nodeSettings: { fill: am5.color(0xba4a00), stroke: am5.color(0xba4a00) } },
                { name: 'Monsoon Malabar', value: 5, nodeSettings: { fill: am5.color(0xba4a00), stroke: am5.color(0xba4a00) } },
                { name: 'Other', value: 1, nodeSettings: { fill: am5.color(0xba4a00), stroke: am5.color(0xba4a00) } },
              ],
            },
            {
              name: 'Papua New Guinea', value: 10,
              nodeSettings: { fill: am5.color(0x212f3d), stroke: am5.color(0x212f3d) },
              children: [
                { name: 'Natural / Dry', value: 2, nodeSettings: { fill: am5.color(0x212f3d), stroke: am5.color(0x212f3d) } },
                { name: 'Washed / Wet', value: 7, nodeSettings: { fill: am5.color(0x212f3d), stroke: am5.color(0x212f3d) } },
                { name: 'Honey / Pulped natural', value: 1, nodeSettings: { fill: am5.color(0x212f3d), stroke: am5.color(0x212f3d) } },
              ],
            },
            {
              name: 'Burundi', value: 8,
              nodeSettings: { fill: am5.color(0x641e16), stroke: am5.color(0x641e16) },
              children: [
                { name: 'Natural / Dry', value: 2, nodeSettings: { fill: am5.color(0x641e16), stroke: am5.color(0x641e16) } },
                { name: 'Washed / Wet', value: 4, nodeSettings: { fill: am5.color(0x641e16), stroke: am5.color(0x641e16) } },
                { name: 'Honey / Pulped natural', value: 2, nodeSettings: { fill: am5.color(0x641e16), stroke: am5.color(0x641e16) } },
              ],
            },
            {
              name: 'Tanzania', value: 6,
              nodeSettings: { fill: am5.color(0x6c3483), stroke: am5.color(0x6c3483) },
              children: [
                { name: 'Natural / Dry', value: 1, nodeSettings: { fill: am5.color(0x6c3483), stroke: am5.color(0x6c3483) } },
                { name: 'Washed / Wet', value: 5, nodeSettings: { fill: am5.color(0x6c3483), stroke: am5.color(0x6c3483) } },
              ],
            },
            {
              name: 'China', value: 3,
              nodeSettings: { fill: am5.color(0x6d4c41), stroke: am5.color(0x6d4c41) },
              children: [
                { name: 'Natural / Dry', value: 1, nodeSettings: { fill: am5.color(0x6d4c41), stroke: am5.color(0x6d4c41) } },
                { name: 'Washed / Wet', value: 1, nodeSettings: { fill: am5.color(0x6d4c41), stroke: am5.color(0x6d4c41) } },
                { name: 'Honey / Pulped natural', value: 1, nodeSettings: { fill: am5.color(0x6d4c41), stroke: am5.color(0x6d4c41) } },
              ],
            },
            {
              name: 'Zambia', value: 2,
              nodeSettings: { fill: am5.color(0x1a237e), stroke: am5.color(0x1a237e) },
              children: [
                { name: 'Natural / Dry', value: 1, nodeSettings: { fill: am5.color(0x1a237e), stroke: am5.color(0x1a237e) } },
                { name: 'Washed / Wet', value: 1, nodeSettings: { fill: am5.color(0x1a237e), stroke: am5.color(0x1a237e) } },
              ],
            },
            {
              name: 'Ecuador', value: 2,
              nodeSettings: { fill: am5.color(0xb7950b), stroke: am5.color(0xb7950b) },
              children: [
                { name: 'Natural / Dry', value: 1, nodeSettings: { fill: am5.color(0xb7950b), stroke: am5.color(0xb7950b) } },
                { name: 'Washed / Wet', value: 1, nodeSettings: { fill: am5.color(0xb7950b), stroke: am5.color(0xb7950b) } },
              ],
            },
            {
              name: 'Bolivia', value: 2,
              nodeSettings: { fill: am5.color(0x6c3483), stroke: am5.color(0x6c3483) },
              children: [
                { name: 'Natural / Dry', value: 1, nodeSettings: { fill: am5.color(0x6c3483), stroke: am5.color(0x6c3483) } },
                { name: 'Washed / Wet', value: 1, nodeSettings: { fill: am5.color(0x6c3483), stroke: am5.color(0x6c3483) } },
              ],
            },
            { name: 'Jamaica', value: 1, nodeSettings: { fill: am5.color(0x1b5e20), stroke: am5.color(0x1b5e20) }, children: [{ name: 'Washed / Wet', value: 1, nodeSettings: { fill: am5.color(0x1b5e20), stroke: am5.color(0x1b5e20) } }] },
            { name: 'Panama', value: 1, nodeSettings: { fill: am5.color(0x0e6251), stroke: am5.color(0x0e6251) }, children: [{ name: 'Natural / Dry', value: 1, nodeSettings: { fill: am5.color(0x0e6251), stroke: am5.color(0x0e6251) } }] },
            { name: 'Australia', value: 1, nodeSettings: { fill: am5.color(0x00695c), stroke: am5.color(0x00695c) }, children: [{ name: 'Natural / Dry', value: 1, nodeSettings: { fill: am5.color(0x00695c), stroke: am5.color(0x00695c) } }] },
          ],
        },
      ]);

      series.set('selectedDataItem', series.dataItems[0]);

      series.events.on('datavalidated', function () {
        setTimeout(function () {
          container.zoomIn(1.2);
        }, 500);
      });
    });
  }

  /* =========================================================
     Init — run all charts
     ========================================================= */
  flavourChart();
  countryOfOriginChart();
  processingMethodChart();
  processingByCountryChart();
})();
